<template>
    <div class="financeSection-content-wrap">
        <div :class="{'financeSection-headerLst': true, spaceBetween: !isMobile || isOpen }">
            <p>Mensalidade <span> {{ handleFinData.fee | format_thousands(true, 2) }} €</span></p>
            <p>TAEG
                <span> {{ handleFinData.taeg | format_thousands(true, 1) }} %</span>

                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"
                @click="showModalPrice(setModalTitle($parent.handleModalFinSimulTitle, true), setFinanceContent($parent.radioCredit, $parent.handleModalFinSimulData))">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
            </p>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            @click="$emit('update:boolIsOpen', true)"
            v-show="isMobile && !isOpen"
            :class="{ active: !isOpen }">
                <path d="M11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071C18.3166 15.0976 17.6834 15.0976 17.2929 14.7071L12 9.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L11.2929 7.29289Z" fill="white"/>
            </svg>
        </div>

        <div v-show="isOpen || !isMobile" class="financeSection-price">
            <p>Preço desde</p>
            <p>
                {{ handleFinData.pvp | format_thousands }} €
            </p>
        </div>

        <div v-show="isOpen || !isMobile" :class="{'financeSection-lst': true}">
            <p>Detalhe:</p>
            <p></p>

            <p>Valor mensal</p>
            <p> {{ handleFinData.fee | format_thousands }} €</p>

            <p>Prazo</p>
            <p> {{ handleFinData.nrPayments}} meses</p>

            <p>TAEG</p>
            <p> {{ handleFinData.taeg | format_thousands(true, 1) }} %</p>

            <p>Montante Financiado</p>
            <p> {{ handleFinData.capitalToFinance | format_thousands }} €</p>

            <p>Entrada Inicial</p>
            <p> {{ handleFinData.initialValue | format_thousands }} €</p>

            <p v-show="handleFinData.residualValue">Última Mensalidade</p>
            <p v-show="handleFinData.residualValue"> {{ handleFinData.residualValue | format_thousands(true) }} €</p>
        </div>
    </div>
</template>
<script>
    import { modalPrice } from '@/mixins/modalFunctions'

    export default {
        name: 'FinanceReqBody',
        props: {
            financeObj: { type: Object, default: () => { return {}; }},
            isOpen: { type: Boolean },
            isMobile: { type: Boolean },
        },
        mixins: [modalPrice],
        data(){return{
            icon: require('@/assets/img/chevFlatDown.webp'),
        }},
        computed: {
            handleFinData(){
                let fO = this.financeObj?.pvp
                if(fO) return this.financeObj
                return 0
            },
        },
    }
</script>
<style lang="scss">

    .financeSection{
        &-content-wrap{ position: relative; }

        &-headerLst > p,
        &-headerLst > p > span{
            @include mixinTypography_new('font_16_24', $whiteCol);
        }

        &-price > p{
            @include mixinTypography_new('font_18_24', $whiteCol);
        }

        &-headerLst > p > span{
            margin-right: .625rem;
        }

        &-headerLst{
            position: relative;
            margin-bottom: 1rem;

            & > :first-child{ margin-bottom: .5rem; }

            svg{ cursor: pointer; }

            span:before{ content: ':'; }

            &.spaceBetween > p{
                display: flex;
                justify-content: space-between;
                align-items: center;
                z-index: 2;
                @include mixinTypography_new('font_18_24', $whiteCol);

                span{ margin-left: auto;
                    &:before{ content: ''; }
                }
            }


            & > svg{
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                z-index: 3;
            }
        }

        &-price{
            display: flex;
            justify-content: space-between;
            margin: 2rem 0;
            padding: 2rem 0;
            border-top: 1px solid #ffffff33;
            border-bottom: 1px solid #ffffff33;

            svg{
                cursor: pointer;
                color: $secondaryCol;
                margin-left: .625rem;
            }
        }

        &-lst{
            display: flex;
            flex-flow: row wrap;
            margin-bottom: 1rem;

            & > *{
                flex-basis: 50%;
                place-self: flex-end;
                margin-bottom: 1rem;
                @include mixin_textContent(1rem, 1rem, $regular, $whiteCol);

                &:first-child{
                    color: $secondaryCol;
                    margin-bottom: 1.5rem;
                    @include mixinTypography_new('font_16_18', $secondaryCol);
                }

                &:nth-child(2n){ text-align: right; }
                span{ @include mixin_textContent(1.5rem, 1.5rem, $bold, $whiteCol); }
            }
        }

        @include respond-to(large){
            &-headerLst > :first-child{ margin-bottom: 1.5rem; }
            &-lst{
                margin-bottom: 3rem;
            }
        }
    }
</style>
